/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import config from '@config';
import RenderSections from '@shi/common/RenderSections';
import WrapLayout from '@shi/components/Layout/WrapLayout';
import HeadComponent from '@shi/components/Utility/HeadComponent';

/* Services */
import { getLocale } from '@shi/Utility/Shared/SharedService';
import { performRequest } from '@utils/microsites/DatoCMSHelperService';
import { getMenuQuery, getQuery } from '@utils/microsites/SHIGqlQueries';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const ShivangaLang = ({ pageData, region, lang }) => {
  // console.log(pageData, "pagedata")
  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Box as="section" className="container-article" p="0" bgColor="#FFEBC7">
        {pageData?.body?.length && pageData?.body?.length
          ? pageData?.body?.map((section, i) => {
            return (
              <RenderSections
                pageData={pageData}
                section={section}
                region={region}
                lang={lang}
                key={nanoid(4)}
              />
            );
          })
          : null}
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const shivangaPaths = [
    `/shivanga/in/en`,
    `/shivanga/us/en`,
    `/shivanga/global/en`,
    `/shivanga/uk/en`,
    `/shivanga/my/en`,
    `/shivanga/sg/en`,
    `/shivanga/ca/en`,
    `/shivanga/au/en`,
    `/shivanga/in/hi`,
    `/shivanga/in/kn`,
    `/shivanga/in/ml`,
    `/shivanga/in/ta`,
    `/shivanga/in/te`,
  ];
  return {
    paths: shivangaPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, lang },
}) => {
  const headerMenuData = await performRequest(
    getMenuQuery('shivangamainmenu'),
    'shivangamainmenu'
  );
  const footerData = await performRequest(
    getMenuQuery('shivangafooter'),
    'shivangafooter'
  );
  const response = await performRequest(getQuery('/', getLocale(region, lang)));
  let pageData = response.allShivangaLandingPages[0] || [];
  // let pageData = response?.allShivangaLandingPages;

  pageData = JSON.stringify(pageData).replace(
    /https:\/\/www.datocms-assets.com\//g,
    `${config.staticPath}/d/`
  );
  pageData = JSON.parse(pageData);

  return {
    props: {
      headerMenuData: headerMenuData || null,
      pageData: pageData || '',
      footerData: footerData || "",
      isPreview: preview ? true : false,
      region: region,
      lang: lang,
      menuType: 'shivangamainmenu',
    },
  };
};

export default ShivangaLang;
